<template>
  <div>
    <div class="title">如何使用优惠券？</div>
    <div class="content-info">
      <p class="txt1">购物车商品确认无误后，点击“去结算”按钮，勾选可使用的优惠券，然后点击“提交订单”即可。</p>
      <ul class="p-left-6">
        <li>
          <img
            src="https://img-oss.yunshanmeicai.com/cfile/a4c61f8274111b16d261365d573abfbf.png"
            width="236"
          />
        </li>
        <li>
          <img
            src="https://img-oss.yunshanmeicai.com/cfile/8a7629d87e13852de8f16a79a955ad91.png"
            width="236"
          />
        </li>
        <li>
          <img
            src="https://img-oss.yunshanmeicai.com/cfile/7ce21f62ba149c6560724e20e09ee72a.png"
            width="236"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
